import React, { useEffect, useState } from "react";

import * as Styled from "./ValueInput.styles";

interface ValueInputProps {
  style?: React.CSSProperties;
  label: string;
  value: number;
  unit?: string;
  isError?: boolean;
  min?: number;
  step?: number;
  onChange: (value: number) => void;
}

const RAW_PATTERN = /^-?\d*[.,]?\d*$/;

export function ValueInput({ style, label, value, unit, isError, min = 0, step = 0.1, onChange }: ValueInputProps) {
  const [text, setText] = useState(String(value));

  useEffect(() => {
    setText(String(value));
  }, [value]);

  return (
    <Styled.ValueInputContainer
      style={style}
      $isError={isError}
    >
      <Styled.ValueInputLabel>{label}</Styled.ValueInputLabel>
      <Styled.ValueInputRow>
        <Styled.ValueInput
          type="text"
          inputMode={step < 1 ? "decimal" : "numeric"}
          value={text}
          $isError={isError}
          onChange={(e) => {
            const raw = e.target.value;
            if (!RAW_PATTERN.test(raw)) return;
            setText(raw);

            const num = parseRaw(raw, step);
            if (!isNaN(num) && num >= min) onChange(num);
          }}
          onBlur={() => {
            if (text.trim() === "") {
              setText("0");
              onChange(0);
              return;
            }

            const num = parseRaw(text, step);
            if (isNaN(num) || num < min) setText(String(value));
          }}
        />
        {unit && <Styled.ValueInputUnit>{unit}</Styled.ValueInputUnit>}
      </Styled.ValueInputRow>
    </Styled.ValueInputContainer>
  );
}

function parseRaw(raw: string, step: number) {
  const normalized = raw.replace(",", ".");
  return step < 1 ? parseFloat(normalized) : parseInt(normalized, 10);
}
